<template>
  <div>
    <b-dropdown
      id="action-button"
      toggle-tag="div"
      toggle-class="p-0 bg-transparent"
      :disabled="disabled"
    >
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('deliveryRequest.actions.changeStatus')"
          class="border-0"
          :disabled="disabled"
        />
      </template>

      <b-dropdown-item
        v-for="item in sortedActionItems"
        :key="item.key"
        @click="handleClickAction(item)"
      >
        <span :style="{ color: item.color }">
          {{ item.label }}
        </span>
      </b-dropdown-item>
    </b-dropdown>
    <RejectModal :isFromList="true" :total="selectedIds.length" @transition="handleTransitionRequest" />
    <AcceptModal :isFromList="true" :total="selectedIds.length" @transition="handleTransitionRequest" />
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import RejectModal from './RejectModal'
import AcceptModal from './AcceptModal'

import * as Request from '@/services/rest-api/lib/request/fleet-task'
import { actionTransitionItemsFleetTask } from '../../lib/constants/action-items'

export default {
  components: {
    McButton,
    RejectModal,
    AcceptModal,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    actionItems() {
      return actionTransitionItemsFleetTask(this.$t.bind(this))
    },
    sortedActionItems() {
      return [...this.actionItems].sort((a, b) => a.key.localeCompare(b.key))
    },
  },
  methods: {
    handleClickAction(item) {
      if (this.selectedIds.length === 0) {
        this.$mcToast.error(this.$t('deliveryRequest.toast.selectDataFirst'))
        return
      }

      const hasInvalidStatus = this.selectedIds.some((item) => item.status !== 'Menunggu')
    
      if (hasInvalidStatus) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                html: this.$t('deliveryRequest.toast.invalidFleetTaskStatus'),
              },
            ],
          },
        })
        return
      }

      this.$bvModal.show(item.idModal)
    },
    async handleTransitionRequest(type, data) {
      const actionItem = this.actionItems.find((item) => item.key === type)

      const payload = {
        ids: this.selectedIds.map((item) => item.id),
        ...data,
      }
      const res = await Request.bulkTransition(payload)
      this.$bvModal.hide(actionItem.idModal)
      if (res.errors) {
        this.$mcToast.error(actionItem.message.failed)
        return
      }
      
      const results = {
        ACCEPT: { success: res.data.success_count, failed: res.data.failed_count },
        REJECT: { success: res.data.success_count, failed: res.data.failed_count },
      }

      this.$bvModal.hide(actionItem.idModal)

      if (type in results) {
        const { success, failed } = results[type]
        if (success > 0)
          this.$mcToast.success(this.$t(
            type === 'ACCEPT'
              ? 'deliveryRequest.toast.fleetTaskAcceptedSuccess'
              : 'deliveryRequest.toast.fleetTaskRejectedSuccess',
            { count: success }
          ))
        if (failed > 0)
          this.$mcToast.error(this.$t(
            type === 'ACCEPT'
              ? 'deliveryRequest.toast.fleetTaskAcceptedFailed'
              : 'deliveryRequest.toast.fleetTaskRejectedFailed',
            { count: failed }
          ))
      }

      this.$emit('refresh-data')
    },
  },
}
</script>
